<smrts-dialog [title]="title" [hasFootnote]="true">

  <div class="content custom-table">

    <div class="custom-table-row">
      <div class="custom-table-col one-column-width">
        <p-floatlabel variant="on">
          <input pInputText fluid [ngModel]="tipoAtual?.nome" readonly />
          <label>Tipo que será movido</label>
        </p-floatlabel>
      </div>
      <div class="custom-table-col one-column-width">
        <app-generic-autocomplete [items]="contas" inputId="conta" displayField="nome" label="Conta destino"
          [(ngModel)]="contaSelecionada">
        </app-generic-autocomplete>
      </div>
    </div>

  </div>

  <div footnote class="inline-element footnote">
    <button class="accent-text-button btn-cancelar" mat-button [mat-dialog-close]="false">
      Cancelar
    </button>
    <button class="white-text-button" mat-flat-button (click)="salvarClick()">
      Salvar
    </button>
  </div>
</smrts-dialog>